export default "__VITE_ASSET__80e6adde__"